import { CoreTimerGameCommunicationProcessor as TimerProcessor  } from '@pp/core/src/controllers/gameCommunication/processors/CoreTimerGameCommunicationProcessor';
import {
  GameCommunicationMessageType,
  GameCommunicationMetaType,
  GameCommunicationSenderType,
  IGameCommunicationProcessor,
} from '@pp/core/src/controllers/gameCommunication/types';
import { CoreStoreType } from '@pp/core/src/store/CoreStore';
import { betActions } from '@pp/core/src/store/slices/bets/slice';
import { configActions } from '@pp/core/src/store/slices/config/slice';

import { BetIds } from '../../../config/bets';
import { HighflyerCoreTimings } from '../../../config/HighflyerCoreTimings';
import { airPlaneActions } from '../../../store/slices/highflyerAirPlane/slice';
import { airplaneStates } from '../../../store/slices/highflyerAirPlane/types';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';

import { GameCommunicationHFBetsOpenProcessor } from './GameCommunicationHFBetsOpenProcessor';

export interface TimerMessage extends GameCommunicationMessageType {
  value: string;
}
export class GameCommunicationTimerProcessor extends TimerProcessor implements IGameCommunicationProcessor {
  delay = 0;
  process(
    message: TimerMessage,
    store: CoreStoreType,
    sender: GameCommunicationSenderType,
    { connectionStatus, connectionProcedure }: GameCommunicationMetaType
  ): void {
    const { highflyerState } = store.getState();
    const timerValue = parseInt(message.value);
    store.dispatch(highflyerGameStateActions.setJackpot(false));
    setTimeout(() => {
      store.dispatch(airPlaneActions.setCurrentState(airplaneStates.READY_TO_FLY));
    }, 1000);
    store.dispatch(betActions.resetBetStack());
    super.process(message, store, sender, { connectionStatus, connectionProcedure });
    BetIds.forEach((betCode) => {
      store.dispatch(highflyerStateActions.resetIsDealingInProgress(betCode));
    });
    store.dispatch(highflyerStateActions.setMultiplier(null));

    store.dispatch(
      configActions.setTimings({
        gameCommunicationDelay: HighflyerCoreTimings.gameCommunicationDelay,
        videoDelayBoundaryMax: HighflyerCoreTimings.videoDelayBoundaryMax,
        videoDelayBoundaryMin: HighflyerCoreTimings.videoDelayBoundaryMin,
        studioLatency: HighflyerCoreTimings.studioLatency,
      })
    );

    store.dispatch(highflyerGameStateActions.showTimerInPLayBtnStatus(true));
    store.dispatch(recentResultDetailStateActions.setInPlayHash(''));
    store.dispatch(highflyerStateActions.setMultiplier(null));
    if (highflyerState.isServerSwitched && timerValue > 0) {
      const betsOpenProcessorInstance = new GameCommunicationHFBetsOpenProcessor(this.store);
      betsOpenProcessorInstance.process(message);
      store.dispatch(highflyerStateActions.setIsServerSwitched(false));
    }
  }
}
